export default "__VITE_ASSET__D05i5L$1__"